import { createContext } from 'react';

const DisabledContext = createContext<boolean>(false);

export default DisabledContext;
